module.exports = __webpack_public_path__ + "img/modal-pic-place.d1635286.png";